//#region frontend/islands/pdp-info-tabs.js
var PDPInfoTabs = class extends HTMLElement {
	connectedCallback() {
		this.tabs = [...this.querySelectorAll("[role=\"tab\"]")];
		this.addEventListener("click", this.onClick);
		this.addEventListener("keydown", this.onKeydown);
	}
	disconnectedCallback() {
		this.removeEventListener("click", this.onClick);
		this.removeEventListener("keydown", this.onKeydown);
	}
	onClick = (e) => {
		const tab = e.target.closest("[role=\"tab\"]");
		if (tab) this.select(tab);
	};
	onKeydown = (e) => {
		const i = this.tabs.indexOf(document.activeElement);
		if (i === -1) return;
		const last = this.tabs.length - 1;
		const next = {
			ArrowRight: i === last ? 0 : i + 1,
			ArrowLeft: i === 0 ? last : i - 1,
			Home: 0,
			End: last
		}[e.key];
		if (next === void 0) return;
		e.preventDefault();
		this.select(this.tabs[next], true);
	};
	select(tab, focus = false) {
		this.tabs.forEach((t) => {
			const selected = t === tab;
			t.setAttribute("aria-selected", selected);
			t.tabIndex = selected ? 0 : -1;
			this.querySelector(`#${t.getAttribute("aria-controls")}`).hidden = !selected;
		});
		if (focus) tab.focus();
	}
};
if (!customElements.get("pdp-info-tabs")) customElements.define("pdp-info-tabs", PDPInfoTabs);
//#endregion
